const screenSizes = {
  xsm: "320px",
  sm: " 540px",
  md: "735px",
  lg: "1070px",
  xlg: "1440px",
}

const responsive = {
  xsm: `@media screen and (max-width: ${screenSizes.xsm})`,
  sm: `@media screen and (max-width: ${screenSizes.sm})`,
  md: `@media screen and (max-width: ${screenSizes.md})`,
  lg: `@media screen and (max-width: ${screenSizes.lg})`,
  xlg: `@media screen and (max-width: ${screenSizes.xlg})`,
}

export default responsive
